import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { brandName } from "../../../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textLightColor,
} from "../../../Constants/Colors";
import logo from "../../../Assets/Images/Logo/Ideal_Corporate_Services.png";
import footerBg from "../../../Assets/Images/Footer/footerbg.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import locationImg from "../../../Assets/Images/Footer/Contact/Location.png";
import phoneImg from "../../../Assets/Images/Footer/Contact/Call.png";
import emailImg from "../../../Assets/Images/Footer/Contact/EMail.png";
import timeImg from "../../../Assets/Images/Footer/Contact/Working-Hours.png";
import { GrSend } from "react-icons/gr";

const Footer = () => {
  return (
    <>
      <Container className="footer-top-container">
        <Row className="align-items-center my-3">
          <Col xs={8} md={9} lg={10}>
            <p className="text-justify footer-top-text">
              We are innovators, problem-solvers, and tech enthusiasts dedicated
              to building digital solutions that drive success. Our passion for
              clean, modern, and scalable software helps businesses stay ahead
              in an ever-evolving digital landscape.
            </p>
          </Col>
          <Col xs={4} md={3} lg={2}>
            <Image src={logo} className="footer-logo" alt="Ideal Logo" />
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        className="footer-container"
        style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Row className="pt-3 pt-md-5 pb-3 px-3 px-md-5">
          <Col
            lg={3}
            md={6}
            className="d-flex flex-column align-items-around justify-content-between"
          >
            <Image src={logo} className="footer-logo" />
            <div className="mt-4 mt-md-0">
              <p className="mb-0">
                Success isn’t just built on code — it’s built on
              </p>
              <h6 style={{ color: primaryColor }}>
                purpose, people, and progress
              </h6>
            </div>

            <div className="d-flex gap-3 mt-4 mt-md-0">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: textLightColor,
                  backgroundColor: primaryColor,
                  borderRadius: "50%",
                  padding: "0.5rem",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaFacebookF />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: textLightColor,
                  backgroundColor: primaryColor,
                  borderRadius: "50%",
                  padding: "0.5rem",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaTwitter />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: textLightColor,
                  backgroundColor: primaryColor,
                  borderRadius: "50%",
                  padding: "0.5rem",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaInstagram />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: textLightColor,
                  backgroundColor: primaryColor,
                  borderRadius: "50%",
                  padding: "0.5rem",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaLinkedinIn />
              </a>
            </div>
          </Col>
          <Col lg={3} md={6} className="pt-3 mt-4 mt-md-0">
            <h4 className="">IT Services</h4>
            <ul className="list-unstyled footer-list ">
              <li>
                <a href="#software-development">Software Development</a>
              </li>
              <li>
                <a href="#web-development">Web Development</a>
              </li>
              <li>
                <a href="#analytic-solutions">Analytic Solutions</a>
              </li>
              <li>
                <a href="#cloud-and-devops">Cloud and DevOps</a>
              </li>
              <li>
                <a href="#product-design">Product Design</a>
              </li>
              <li>
                <a href="#seo-marketing">SEO & Marketing</a>
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="pt-0 pt-md-3 mt-4 mt-md-5 mt-lg-0">
            <h4 className="">Contact Info</h4>
            <ul className="list-unstyled footer-list ">
              <li className="d-flex ">
                {" "}
                <Image
                  src={locationImg}
                  alt="Location"
                  className="me-2 footer-contact-icon"
                />{" "}
                #71, 3rd Main Road,
                <br /> Lakshmi Nagar Ext,
                <br /> Porur, Chennai 600116
              </li>
              <li>
                {" "}
                <Image
                  src={phoneImg}
                  alt="Phone"
                  className="me-2 footer-contact-icon"
                />{" "}
                +91 6379517451
              </li>
              <li>
                {" "}
                <Image
                  src={emailImg}
                  alt="Email"
                  className="me-2 footer-contact-icon"
                />{" "}
                info@idealcorp.in
              </li>
              <li>
                {" "}
                <Image
                  src={timeImg}
                  alt="Working Hours"
                  className="me-2 footer-contact-icon"
                />{" "}
                Opening Hours: 10:00 - 18:00
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="pt-3 mt-md-5 mt-lg-0">
            <h4>Newsletter</h4>
            <ul className="list-unstyled footer-list">
              <li>
                Stay in the loop — sign up for insights, updates, and cool stuff
                we build.
              </li>
              <li className="mt-5">
                <div className="input-group mt-2 mail-section">
                  <Form.Control
                    type="email"
                    placeholder="your email"
                    className="rounded-pill rounded-end-0 ps-4 py-2"
                    style={{ fontSize: "14px" }}
                  />
                  <Button
                    style={{
                      background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
                      border: "none",
                      marginLeft: "-20px",
                      zIndex: 999,
                    }}
                    type="submit"
                    className="rounded-pill "
                  >
                    <GrSend />
                  </Button>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
        <Row
          className="py-2 mb-3"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.7)" }}
        >
          <Col
            xs={12} lg={6}
            className="m-auto"
          >
            <p className="m-auto float-lg-end" style={{ fontStyle: "italic" }}>
              Copyright © {new Date().getFullYear()} All Rights Reserved | By{" "}
              {brandName}
            </p>
          </Col>
          <Col xs={12} lg={6} className="d-none d-lg-block">
            <ul className="d-flex flex-row footer-nav float-lg-end">
              <li className="me-5 list-unstyled">Home</li>
              <li className="me-5">About</li>
              <li className="me-5">Blog</li>
              <li className="me-5">Works</li>
              <li>FAQs</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
